const batchGochiChargeStatuses = [
  {
    id: 0,
    name: '選択なし',
    value: ''
  },
  {
    id: 1,
    name: '未登録',
    value: 'NEW'
  },
  {
    id: 2,
    name: '処理中',
    value: 'INPROCESS'
  },
  {
    id: 3,
    name: '成功',
    value: 'SUCCESS'
  },
  {
    id: 4,
    name: '失敗',
    value: 'ERROR'
  }
];

export default batchGochiChargeStatuses;
